import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

export class StatsCard extends Component {
  render() {
    return (
      <div className="card card-stats clickable" onClick={() => this.props.onClick()}>
        <div className="content">
          <Row>
            <Col xs={7}>
              <div className="numbers pull-left">
                <p>{this.props.statsText}</p>
                <span className="pull-left">{this.props.statsValue}</span>
              </div>
            </Col>
            <Col xs={5}>
              <div className="icon-big text-right icon-warning">
                {this.props.bigIcon}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default StatsCard;
